import type { PortableTextBlock } from '@portabletext/react'
import React, { useMemo } from 'react'

import { SimpleSelectableOption } from '@/components/Shared/SimpleSelectableOption'
import { PurchaseTypes } from '@/constants/programs'
import type { SelectedOptionsState } from '@/hooks/useFlexibleProgram'
import type { CMSProgramOption } from '@/types/sanity'
import { formatPrice } from '@/utilities/number'

type Props = {
  label: string
  tag?: string
  description?: PortableTextBlock[]
  isSelected?: boolean
  option: CMSProgramOption
  variant?: {
    sku: string
    price: number
  }
  selectedOptions: SelectedOptionsState
  onChange: (args: { label: string; option: CMSProgramOption }) => void
}

export const Item: React.FC<Props> = ({
  label,
  tag,
  description,
  isSelected,
  option,
  variant,
  selectedOptions,
  onChange,
}) => {
  const formattedPrice = useMemo(() => {
    if (!variant) return undefined

    if (
      selectedOptions.purchaseType === PurchaseTypes.PACK_OF_WEEKS &&
      selectedOptions.weeks
    ) {
      const pricePerWeek = variant.price / selectedOptions.weeks
      return `(${formatPrice(pricePerWeek, { displayTrailingZeros: true })}/wk)`
    } else if (selectedOptions.purchaseType === PurchaseTypes.SUBSCRIPTION) {
      return `(${formatPrice(variant.price, {
        displayTrailingZeros: true,
      })}/wk)`
    }

    return undefined
  }, [variant, selectedOptions.purchaseType, selectedOptions.weeks])

  return (
    <SimpleSelectableOption
      type="radio"
      id={option._id}
      name={option._type}
      value={option._id}
      label={label}
      subcontent={formattedPrice}
      tag={tag}
      tagTheme="lime"
      description={description}
      checked={isSelected}
      onChange={() =>
        onChange({
          label: label,
          option: option,
        })
      }
    />
  )
}
